import { useContext, useEffect, useState } from "react";
import Page from "src/components/Report/Page";
import jobContext from "src/context/jobContext";

export default function Page2() {
    const { job } = useContext(jobContext)
    const [data, setData] = useState({})
    useEffect(() => {
        if (job.data) {
            setData(JSON.parse(job.data))
        }
    }, [job])

    let vazayefNumber = 0;
    return (
        <Page pageNumber={2}>
            <div className="flex flex-col gap-3">
                <div className="font-bold text-lg">
                    شرح وظایف:
                </div>
                <div>
                    <ul>
                        {data?.baseInfo ?
                            Object.keys(data?.baseInfo).map((key, index) => {
                                if (key.includes("وظیفه تخصصی")) {
                                    vazayefNumber++;
                                    return (<li className="odd-color" key={index}>{vazayefNumber}) {data?.baseInfo[key]}</li>)
                                }
                            }) :
                            null
                        }
                        {
                            data?.vazayefOmoomi ?
                                Object.keys(data?.vazayefOmoomi).map((key, index) => {
                                    if (data?.vazayefOmoomi[key]) {
                                        vazayefNumber++;
                                        return (<li className="odd-color" key={index}>{vazayefNumber}) {key}</li>)
                                    }
                                })
                                :
                                null
                        }
                    </ul>
                </div>
            </div>
        </Page>
    )
}